module.exports = __webpack_public_path__ + "static/img/collect_02.8bf992b6.png";